import type { AxiosRequestConfig } from 'axios';
import { API_PRE_URL } from '@/constants';
import axios from '@/service/request';
import type { R } from './types';

const HANEDA_GOODS_API_BASE = "production" === 'development'
  ? `${window.location.origin}/api/open/api/haneda/goods`
  : `${API_PRE_URL}/open/api/haneda/goods`;

export interface HanedaClassificationRequest {
  onlyFirstLevel?: boolean;
  storeId?: number | null;
}

export interface HanedaClassification {
  id: number;
  parentId: number;
  name: string;
  level: number;
  sort?: number;
  imgUrl?: string;
  langExt?: string;
  children?: HanedaClassification[] | null;
}

export interface HanedaGoodsPageRequest {
  classificationId: number;
  current?: number;
  size?: number;
  keyword?: string;
  storeId?: number | null;
}

export interface HanedaTerminalLabel {
  name: string;
  langExt?: string | null;
}

export interface HanedaGoods {
  spuId: number;
  name: string;
  imgUrl?: string;
  fullImgUrl?: string;
  price?: number;
  priceCny?: number;
  marketPrice?: number;
  marketPriceCny?: number;
  brandName?: string;
  stockAmount?: number;
  soldAmount?: number;
  sellerId?: number;
  categoryId1?: number;
  categoryId2?: number;
  categoryId3?: number;
  detailUrl?: string;
  /** 多语言扩展，JSON 字符串，如 {"jp":{"name":"..."},"en":{"name":"..."}} */
  langExt?: string;
  subheading?: string;
  desc1?: string;
  /** 航站楼标签，如 T2出发 / T3出发 */
  terminalLabels?: HanedaTerminalLabel[] | null;
}

export interface HanedaGoodsPage {
  current: number;
  size: number;
  total: number;
  records: HanedaGoods[];
}

export const apiHanedaClassifications = (
  data: HanedaClassificationRequest,
  config?: AxiosRequestConfig,
): Promise<R<HanedaClassification[]>> => {
  return axios.post(`${HANEDA_GOODS_API_BASE}/classifications`, data, config);
};

export const apiHanedaGoodsPage = (
  data: HanedaGoodsPageRequest,
  config?: AxiosRequestConfig,
): Promise<R<HanedaGoodsPage>> => {
  return axios.post(`${HANEDA_GOODS_API_BASE}/page`, data, config);
};
